import { render, staticRenderFns } from "./gold.vue?vue&type=template&id=49ef5f70&scoped=true"
import script from "./gold.vue?vue&type=script&lang=js"
export * from "./gold.vue?vue&type=script&lang=js"
import style0 from "./gold.vue?vue&type=style&index=0&id=49ef5f70&prod&lang=less"
import style1 from "./gold.vue?vue&type=style&index=1&id=49ef5f70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef5f70",
  null
  
)

export default component.exports